<template>
	<l-marker
		ref="marker"
		v-bind:lat-lng="fromGeoJson(offer.location.geo)"
		v-on:click="toggleActive"
	>
		<l-icon
			ref="icon"
			:icon-url="iconUrl"
			v-bind:popup-anchor="[0, -10]"
			v-bind:icon-size="isActive ? [28, 28] : [20, 20]"
		/>
		<l-popup ref="popup" class="font-sans text-base p-3">
			<div class="whitespace-nowrap flex space-x-2 items-baseline mr-8">
				<crop-product-summary
					class="font-medium text-gray-900"
					:tradable="offer"
				/>
				<!-- <div class="text-gray-500 text-xs pr-4">{{offer.trade == 'SELL' ? __('Seller') : __('Buyer') }}</div> -->
			</div>

			<div class="text-sm">{{ $cropOptions.dateToString(offer, locale) }}</div>
			<div class="text-sm">
				<span
					v-if="
						user &&
						user.type == 'FARMER' &&
						offer.trade == 'BUY' &&
						offer.location.mode == 'DAP' &&
						offer.location.optional_transport
					"
				>
					{{
						$cropOptions.getLocalizedLabel(
							"FCA",
							$cropOptions.locationModeOptions
						)
					}}
				</span>
				<span v-else>
					{{
						$cropOptions.getLocalizedLabel(
							offer.location.mode,
							$cropOptions.locationModeOptions
						)
					}}
				</span>
			</div>

			<div class="flex justify-between font-semibold">
				<span>{{ offer.qty.mt }} t</span>
				<span v-if="acl.see_price">
					<span
						v-if="
							user &&
							user.type == 'FARMER' &&
							offer.trade == 'BUY' &&
							offer.location.mode == 'DAP' &&
							offer.location.optional_transport &&
							item.price_estimate
						"
					>
						{{
							item.price_estimate
								? $cropOptions.formatLocalizedNumber(item.price_estimate) +
								  " €/t"
								: __("n.a.")
						}}
					</span>
					<span v-else>
						{{
							offer.price.mt
								? $cropOptions.formatLocalizedNumber(offer.price.mt) + " €/t"
								: ""
						}}
					</span>
				</span>
			</div>
			<div class="flex">
				<button
					v-if="activeThreadUrl"
					type="primary"
					class="ml-auto text-sm mt-2"
					v-on:click="$inertia.visit(activeThreadUrl)"
				>
					{{ __("Go to negotiation") }}
				</button>
				<ui-button
					v-else
					type="primary"
					class="ml-auto text-sm mt-2"
					v-on:click="maybeBid()"
					:label="
						item.offer.trade == 'BUY' ? 'Go to Buy Offer' : 'Go to Sell Offer'
					"
				/>
			</div>
		</l-popup>
	</l-marker>
</template>

<script>
// http://localhost:6103/images/leaflet-color-markers/img/map-pointer-green.svg
let options = require("../../cropOptions.js");
import {
	LMap,
	LTileLayer,
	LFeatureGroup,
	LMarker,
	LPopup,
	LIcon,
} from "vue2-leaflet";

export default {
	props: {
		item: {
			type: Object,
			required: true,
		},
		activeId: {
			type: String,
			required: false,
		},
		user: {
			type: Object,
			required: false,
		},
	},
	components: {
		LIcon,
		LMarker,
		LPopup,
	},
	computed: {
		iconUrl: function () {
			let trade = this.offer.trade.toLowerCase(),
				icon = [
					trade == "buy" ? "square-orange" : "circle-green",
					this.isActive ? ".active" : "",
					".svg",
				].join("");
			return window.baseUrl + "/images/leaflet-color-markers/img/" + icon;
		},
		isActive() {
			return this.activeId != null && this.activeId == this.item.match_id;
		},
		activeThreadUrl() {
			let t = this.item.threads.filter((t) => t.status == "UNDER_NEGOTIATION");
			if (t.length > 0) {
				return this.$route("threads", { active_id: this.item.threads[0].id });
			}
		},
	},
	data() {
		return {
			offer: this.item.offer,
			acl: this.$inertia.page.props.acl,
		};
	},
	methods: {
		fromGeoJson: function (geoJ) {
			return {
				lat: geoJ.coordinates[1],
				lng: geoJ.coordinates[0],
			};
		},
		iconBaseUrl: function () {
			return window.baseUrl + "/images/leaflet-color-markers/img/";
			// return "/images/leaflet-color-markers/img/";
		},
		toggleActive() {
			this.$root.$emit("new-active-marker-id", this.item.match_id);
			//this.iconUrl = this.iconBaseUrl() + 'map-pointer-orange.svg'
		},
		maybeBid() {
			if (this.acl.can_trade) {
				this.$bus.$emit(
					"toggle-iframe-modal",
					this.$route("bid.create", {
						targetType: this.offer.trade,
						targetId: this.offer.id,
					})
				);
			} else {
				this.$bus.$emit("toggle-permission-denied-modal");
			}
		},
	},
	watch: {
		activeId: function (newActiveId) {
			console.log("new active marker", newActiveId);
			if (newActiveId != this.item.match_id) {
				// popup should be closed
				this.$refs.marker.mapObject.closePopup();
				this.$refs.marker.mapObject.options.zIndexOffset = 0;
			} else {
				this.$refs.marker.mapObject.openPopup();
				this.$refs.marker.mapObject.options.zIndexOffset = 6100;
			}
		},
	},
};
</script>
